export default __webpack_public_path__ + "static/IN-8015HD_Quick-Installation_P2P-WPS_01-f6c7aa8670a09dcff6d12fc6e14a967a.webp";